import React, {useState} from 'react';
import ServiceApplyInfo from "./subpage/ServiceApplyInfo";
import {DetailHeroSummaryProvider, DetailTabBar} from "../../../components/detailLayout";
import {CommonHistoryList} from "../../settings/history/subPages/CommonHistoryList";
import {useParams} from "react-router-dom";

const ServiceApplyView = () => {
    const [tabs, setTabs] = useState([
        {clicked: true, name: "기본정보"},
        {clicked: false, name: "이력상세"},
    ]);
    const {id} = useParams();

    return (
        <div className="common-container container-height detail-list-layout asset-detail-list-layout border-l-gray">
            <DetailHeroSummaryProvider>
                <DetailTabBar tabs={tabs} setTabs={setTabs} />
                {tabs[0].clicked && <ServiceApplyInfo key={id} />}
                {tabs[1].clicked && <CommonHistoryList id={id} tableName={"서비스신청"} />}
            </DetailHeroSummaryProvider>
        </div>
    );
};

export default ServiceApplyView;
